import React from "react";
import {Box, IconButton, Typography} from "@mui/material";
import {Api, CellTower, Code, ErrorOutline, ManageAccounts, MonitorHeart, Notes, Subscriptions, ViewInAr} from "@mui/icons-material";
import {Blue3} from "../../theme/styles";
import css_self from "../../pages/css/Pages.module.scss";
import bill_logo from "../../assets/bill-logo.png";
import onshape_logo from "../../assets/onshape.jpeg";
import solidworks_logo from "../../assets/solidworks.jpeg";
import css_buttons from "../../components/Common/css/CCButton.module.scss";
import {useNavigate} from "react-router-dom";


export default function DeveloperMenu() {
    const navigate = useNavigate();

    return (
        <Box sx={{p: 2, bgcolor: "background.paper", width: "375px", height: "500px"}}>
            <div style={{display: "flex", flexDirection: "column", padding: "10px"}}>
                <div style={{display: "flex", flexDirection: "row", alignContent: "flex-start"}}>
                    <div style={{width: "125px", display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                        <IconButton className={css_self.AppMenuButton}
                            onClick={() => {
                                navigate("/dashboard/rest-api-management");
                            }}>
                            <ManageAccounts sx={{color: Blue3, width: 45, height: 45}}/>
                        </IconButton>
                        <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>REST API Management</Typography>
                    </div>
                    <div style={{width: "125px", display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                        <IconButton className={css_self.AppMenuButton}
                            onClick={() => {
                                navigate("/dashboard/endpoint-management");
                            }}>
                            <Api sx={{color: Blue3, width: 45, height: 45}}/>
                        </IconButton>
                        <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Endpoint Management</Typography>
                    </div>
                    <div style={{width: "125px", display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                        <IconButton className={css_self.AppMenuButton}
                            onClick={() => {
                                navigate("/dashboard/event-management");
                            }}>
                            <CellTower sx={{color: Blue3, width: 45, height: 45}}/>
                        </IconButton>
                        <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Event Management</Typography>
                    </div>
                </div>
                <div style={{marginTop: "20px", display: "flex", flexDirection: "row", alignContent: "flex-start"}}>
                    <div style={{width: "125px", display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                        <IconButton className={css_self.AppMenuButton}
                            onClick={() => {
                                navigate("/dashboard/monitoring");
                            }}>
                            <MonitorHeart sx={{color: Blue3, width: 45, height: 45}}/>
                        </IconButton>
                        <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Monitoring</Typography>
                    </div>
                    <div style={{width: "125px", display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                        <IconButton className={css_self.AppMenuButton}
                            onClick={() => {
                                navigate("/dashboard/exception-management");
                            }}>
                            <ErrorOutline sx={{color: Blue3, width: 45, height: 45}}/>
                        </IconButton>
                        <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Exception Management</Typography>
                    </div>
                    <div style={{width: "125px", display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                        <IconButton className={css_self.AppMenuButton}
                            onClick={() => {
                                navigate("/dashboard/sandbox-management");
                            }}>
                            <ViewInAr sx={{color: Blue3, width: 45, height: 45}}/>
                        </IconButton>
                        <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Sandbox Management</Typography>
                    </div>
                </div>
                <div style={{marginTop: "20px", display: "flex", flexDirection: "row", alignContent: "flex-start"}}>
                    <div style={{width: "125px", display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                        <IconButton className={css_self.AppMenuButton}
                            onClick={() => {
                                navigate("/dashboard/log-management");
                            }}>
                            <Notes sx={{color: Blue3, width: 45, height: 45}}/>
                        </IconButton>
                        <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Log Management</Typography>
                    </div>
                    <div style={{width: "125px", display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                        <IconButton className={css_self.AppMenuButton}
                            onClick={() => {
                                navigate("/dashboard/bill-configuration");
                            }}>
                            <img alt="bill logo" src={bill_logo} style={{color: Blue3, width: "45px", height: "45px"}}/>
                        </IconButton>
                        <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Bill.com Configuration</Typography>
                    </div>
                    <div style={{width: "125px", display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                        <IconButton className={css_self.AppMenuButton}
                            onClick={() => {
                                navigate("/dashboard/onshape-configuration");
                            }}>
                            <img alt="onshape logo" src={onshape_logo} style={{color: Blue3, width: "45px", height: "45px"}}/>
                        </IconButton>
                        <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Onshape Configuration</Typography>
                    </div>
                </div>
                <div style={{marginTop: "20px", display: "flex", flexDirection: "row", alignContent: "flex-start"}}>
                    <div style={{width: "125px", display: "flex", flexDirection: "column", justifyContent: "center", marginTop: "10px", marginLeft: "auto", marginRight: "auto"}}>
                        <IconButton className={css_buttons.blueIconButton} onClick={() => {
                            navigate("/dashboard/solidworks-configuration");
                        }}>
                            <img alt="solidworks logo" src={solidworks_logo} style={{color: Blue3, width: "75px", height: "75px"}}/>
                        </IconButton>
                        <Typography style={{marginTop: "20px", fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Solidworks<br/>Configuration</Typography>
                    </div>
                    <div style={{width: "125px", display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                        <IconButton className={css_self.AppMenuButton}
                            onClick={() => {
                                navigate("/dashboard/subscription-management");
                            }}>
                            <Subscriptions sx={{color: Blue3, width: "45px", height: "45px"}}/>
                        </IconButton>
                        <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Subscription Management</Typography>
                    </div>
                    <div style={{width: "125px", display: "flex", flexDirection: "column", justifyContent: "center", marginLeft: "auto", marginRight: "auto"}}>
                        <IconButton className={css_self.AppMenuButton}
                            onClick={() => {
                                navigate("/dashboard/integration-template");
                            }}>
                            <Code sx={{color: Blue3, width: "45px", height: "45px"}}/>
                        </IconButton>
                        <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000", textAlign: "center"}}>Integration Template</Typography>
                    </div>
                </div>
            </div>
        </Box>
    )
}
